import { Checkbox } from '@/components/ui/checkbox.tsx'
import { Label } from '@/components/ui/label.tsx'
import { cn } from '@/lib/utils.ts'
import type { CheckedState } from '@radix-ui/react-checkbox'

type Props = {
  variant: 'primary' | 'secondary'
  id: string
  labelText: string
  checked?: CheckedState | undefined
  onCheckChange?: (checked: CheckedState) => void
  disabled?: boolean | undefined
  className?: string
}

export const CheckboxWithLabel = ({ variant, id, labelText, checked, onCheckChange, disabled, className }: Props) => {
  const primaryStyle = 'bg-interactive-inactive text-contents-primary '
  const primaryHover =
    'relative hover:after:bg-stateLayer-onLight-hovered hover:after:opacity-8 after:absolute after:inset-0 after:pointer-events-none'
  const primaryActive = 'bg-interactive-secondary text-contents-onDarkPrimary'
  const primaryDisabled = 'bg-interactive-inactive text-contents-onDarkPrimary'

  const secondaryStyle =
    'bg-transparent text-contents-secondary flex gap-1 items-center cursor-pointer p-2 rounded-sm font-EN-KR-body2-regular hover:bg-interactive-inactive'
  const secondaryHoverStyle =
    'relative hover:interactive-inactive hover:after:bg-stateLayer-onLight-hovered hover:after:opacity-8 after:absolute after:inset-0 after:pointer-events-none'
  const secondaryActive = 'bg-interactive-primary hover:bg-interactive-primary text-contents-onDarkPrimary'

  const getStyle = () => {
    if (variant === 'primary') {
      return cn(primaryStyle, primaryHover, checked && primaryActive, disabled && primaryDisabled)
    }
    return cn(secondaryStyle, secondaryHoverStyle, checked && secondaryActive)
  }

  return (
    <Label
      htmlFor={id}
      className={cn(
        'font-EN-KR-body2-regular flex items-center gap-1 rounded-sm p-2 cursor-pointer overflow-hidden',
        getStyle(),
        className,
      )}
    >
      <Checkbox
        id={id}
        variant="custom"
        size="md"
        checked={checked}
        disabled={disabled}
        onCheckedChange={onCheckChange}
      />
      {labelText}
    </Label>
  )
}
